import React from "react";
import { CallDataInfo } from "../../../models/customer-analytics/customer-analytics.model";

interface CallStatusCellProps {
  callDataJson: string | null;
}

const CallStatusCell: React.FC<CallStatusCellProps> = ({ callDataJson }) => {
  const parseCallData = (): CallDataInfo | null => {
    if (!callDataJson) return null;
    try {
      const parsed = JSON.parse(callDataJson);
      return {
        callStatusId: parsed.CallStatusId ?? parsed.callStatusId,
        callStatusName: parsed.CallStatusName ?? parsed.callStatusName,
        createdDate: parsed.CreatedDate ?? parsed.createdDate,
      };
    } catch {
      return null;
    }
  };

  const getDaysAgo = (dateString: string): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    return `${diffDays} days ago`;
  };

  const callInfo = parseCallData();

  if (!callInfo) {
    return <span className="text-xs text-400">No calls</span>;
  }

  return (
    <span className="text-sm">
      <span className="font-semibold">{callInfo.callStatusName}</span>
      <br />
      <span className="text-xs text-500">{getDaysAgo(callInfo.createdDate)}</span>
    </span>
  );
};

export default CallStatusCell;
